module.exports = __webpack_public_path__ + "beb6377c10fa4aa3a6c04de4cddbc787.png";